import React from 'react';
import PropTypes from 'prop-types';

import { ContractWrapper } from './Styled';
import { Container, Margin } from '../../common/base';
import { Anchor, Grid, Col } from '../../common/interfaces';

import { withTranslation } from '../../common/libs/i18n';

const HomeContract = ({ t }) => (
  <ContractWrapper>
    <Container>
      <Grid text="center">
        <Col lg={12} sm={12}>
          <Margin vertical={24}>
            <Anchor
              type="button"
              color="white"
              size="large"
              target="_blank"
              rel="noreferrer noopener"
              href={t(
                'landing.examine.idrt.url',
                'https://etherscan.io/token/0x998FFE1E43fAcffb941dc337dD0468d52bA5b48A'
              )}
            >
              {t('landing.examine.idrt.token', 'Examine IDRT on the Ethereum blockchain')}
            </Anchor>
          </Margin>
        </Col>
      </Grid>
    </Container>
  </ContractWrapper>
);

HomeContract.propTypes = {
  t: PropTypes.func
};

export default withTranslation('common')(HomeContract);
